import { render, staticRenderFns } from "./ModeratorSuperAdminPreSelect.vue?vue&type=template&id=2454d930"
import script from "./ModeratorSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./ModeratorSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports